class CustomershipStatus {
    static Potential() {
        return 1;
    }
    static Active() {
        return 2;
    }
    static Lead() {
        return 3;
    }
}

export default CustomershipStatus;
